import L10n from "lib/carrot-l10n"
import { Paths } from "./Paths"

const l = new L10n({ locale: "en-US" }).getBoundLocalize()

const map = {

  "/account": l`client.account.settings`,

  "/chat": l`client.experts.chat`,

  "/read": l`client.library.title`,

  "/reimbursements/": l`Get reimbursed`,

  "/transactions": l`yourBenefit`,

  "/providerfinder": l`providerFinder`,

  "/support": l`client.support.carrotCardSupport`,

  "/talk-to-carrot": l`Talk to Carrot`,

  "/request-card": l`Get your Carrot Card®`
}

export default (pathname) => {
  if (pathname === "/") return l`client.home.title`
  map[Paths.DIGITAL_BENEFITS_GUIDE] = l`Your Benefit Guide`
  for (const key in map) {
    if (pathname.startsWith(key)) return map[key]
  }
  return "404"
}
